import script from "./NotificationDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationDrawer.vue?vue&type=style&index=0&id=c2d3ff3e&lang=scss"

const __exports__ = script;

export default __exports__